// Opacity-only reveal for every .reveal-fade element: marks it [data-revealed] when it enters
window.electronixoRevealReady = true
// the viewport, staggering items that arrive together. Also watches for elements added later
// (Load more, filter refreshes, partial swaps). Reduced motion reveals everything at once.
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const root = document.documentElement;

function revealAll() {
  document.querySelectorAll('.reveal-fade:not([data-revealed]), .xo-onview:not([data-revealed])').forEach((el) => el.setAttribute('data-revealed', ''));
}

if (reduce.matches || !('IntersectionObserver' in window)) {
  revealAll();
  root.classList.remove('js-reveal');
} else {
  const observer = new IntersectionObserver((entries) => {
    const entering = entries.filter((entry) => entry.isIntersecting);
    entering.forEach((entry, i) => {
      entry.target.style.setProperty('--reveal-delay', `${Math.min(i, 8) * 70}ms`);
      entry.target.setAttribute('data-revealed', '');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px 0px 0px', threshold: 0.01 });

  const watch = (scope) => {
    scope.querySelectorAll?.('.reveal-fade:not([data-revealed]), .xo-onview:not([data-revealed])').forEach((el) => observer.observe(el));
    if (scope.matches?.('.reveal-fade:not([data-revealed]), .xo-onview:not([data-revealed])')) observer.observe(scope);
  };

  // Site-wide scroll animation: tag the main content blocks on every page so they animate in
  // as they scroll into view. Cards open their frame; other blocks rise in. Already-animated
  // areas, the header, dialogs and anything visible on first paint are left alone (no flash).
  const autoTag = () => {
    const main = document.getElementById('main-content');
    if (!main) return;
    const h = window.innerHeight;
    const skip = (el) =>
      el.closest('[class*="xo-a-"], .reveal-fade, .xo-onview, dialog, header, [data-xo-auto]') ||
      el.getBoundingClientRect().top < h;
    const tag = (el, type) => {
      if (skip(el)) return;
      el.setAttribute('data-xo-auto', type);
      el.classList.add('xo-onview');
    };
    main.querySelectorAll('article.group\\/card').forEach((el) => tag(el, 'open'));
    main
      .querySelectorAll('h1, h2, h3:not(article h3), .richtext, section, s-product-gallery, [data-product-price], details, table, form:not(article form), nav[aria-label], .xo-tag')
      .forEach((el) => tag(el, 'up'));
    const footerCard = document.querySelector('footer .xo-card');
    if (footerCard) tag(footerCard, 'open');
  };
  autoTag();

  watch(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) watch(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });

  // Safety net: never leave content hidden if something goes wrong.
  setTimeout(() => {
    document.querySelectorAll('.reveal-fade:not([data-revealed]), .xo-onview:not([data-revealed])').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) el.setAttribute('data-revealed', '');
    });
  }, 2500);
}

// Safety net: anything still hidden that is on screen after scrolling/resizing gets revealed,
// so a section can never stay invisible if the observer missed it.
(() => {
  let queued = false;
  const check = () => {
    queued = false;
    const h = window.innerHeight;
    document.querySelectorAll('.reveal-fade:not([data-revealed]), .xo-onview:not([data-revealed])').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < h && r.bottom > 0) el.setAttribute('data-revealed', '');
    });
  };
  const queue = () => { if (!queued) { queued = true; setTimeout(check, 250); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
})();
